<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      height="800"
      allowtransparency
    ></iframe>
  </div>
</template>

<script>
import { dashboardUrl } from "@/helpers/dashboards";
export default {
  data() {
    return {
      url:
        dashboardUrl("visites")
    };
  },
  created() {
  },
};
</script>
